var Perseides = Perseides || {};
(function ($, window, document, Perseides, Analyzr, undefined) {
    "use strict";

    window.PerseidesTheme = function () {
        var app = this;

	    /**
	     * Initialisation du menu mobile principal
	     */
	    app.initMainMenuMobile = function () {
		    "use strict";

		    // Paramètres et callbacks
		    var customParams = {
			        closedSymbol: '<svg class="icon icon-triangle-droite"><use xlink:href="#icon-triangle-droite"/></svg>',
			        openedSymbol: '<svg class="icon icon-triangle-bas"><use xlink:href="#icon-triangle-bas"/></svg>'
		        },
		        customCallbacks = {};

		    return Perseides.Functions.initializeSlickNav($('#mainNav'), customParams, customCallbacks);
	    };


	    /**
	     * Désactivation du premier clic sur un menu principal contenant un sous-menu
	     */
	    app.menuPrincShowSubMenuOnTouchDevice = function () {
		    "use strict";

		    return Perseides.Functions.linkDeactivateFirstClickForSubNav('mainNav', '.menu-item-has-children > a');
	    };


	    /**
	     * Désactivation du premier clic sur un menu principal contenant un sous-menu - Menu dans le footer
	     */
	    app.footerMenuPrincShowSubMenuOnTouchDevice = function () {
		    "use strict";

		    return Perseides.Functions.linkDeactivateFirstClickForSubNav('footerMainNav', '.menu-item-has-children > a');
	    };


        /**
         * Initialisation d'une carte Google
         */
        app.initGoogleMap = function () {
            "use strict";

	        var initGMap = this;
	        var apiKey = 'AIzaSyDNjSq8q3i4KRIZ8h7TcR4rYk-Bngs7-A0';

	        initGMap.initialize = function( position ) {
		        var couleurMap = [
			        {
				        "featureType": "administrative",
				        "elementType": "labels.text.fill",
				        "stylers": [
					        {
						        "color": "#444444"
					        }
				        ]
			        },
			        {
				        "featureType": "landscape",
				        "elementType": "all",
				        "stylers": [
					        {
						        "color": "#f2f2f2"
					        }
				        ]
			        },
			        {
				        "featureType": "poi",
				        "elementType": "all",
				        "stylers": [
					        {
						        "visibility": "off"
					        }
				        ]
			        },
			        {
				        "featureType": "poi",
				        "elementType": "labels.icon",
				        "stylers": [
					        {
						        "visibility": "off"
					        }
				        ]
			        },
			        {
				        "featureType": "road",
				        "elementType": "all",
				        "stylers": [
					        {
						        "saturation": -100
					        },
					        {
						        "lightness": 45
					        }
				        ]
			        },
			        {
				        "featureType": "road",
				        "elementType": "geometry.fill",
				        "stylers": [
					        {
						        "visibility": "on"
					        }
				        ]
			        },
			        {
				        "featureType": "road.highway",
				        "elementType": "all",
				        "stylers": [
					        {
						        "visibility": "simplified"
					        }
				        ]
			        },
			        {
				        "featureType": "road.highway",
				        "elementType": "geometry.fill",
				        "stylers": [
					        {
						        "visibility": "on"
					        },
					        {
						        "color": "#69a606"
					        }
				        ]
			        },
			        {
				        "featureType": "road.arterial",
				        "elementType": "geometry.fill",
				        "stylers": [
					        {
						        "color": "#69a606"
					        }
				        ]
			        },
			        {
				        "featureType": "road.arterial",
				        "elementType": "labels.text.fill",
				        "stylers": [
					        {
						        "color": "#69a606"
					        }
				        ]
			        },
			        {
				        "featureType": "road.arterial",
				        "elementType": "labels.text.stroke",
				        "stylers": [
					        {
						        "color": "#fdfdfd"
					        },
					        {
						        "weight": "4"
					        }
				        ]
			        },
			        {
				        "featureType": "road.arterial",
				        "elementType": "labels.icon",
				        "stylers": [
					        {
						        "visibility": "off"
					        }
				        ]
			        },
			        {
				        "featureType": "transit",
				        "elementType": "all",
				        "stylers": [
					        {
						        "visibility": "off"
					        }
				        ]
			        },
			        {
				        "featureType": "water",
				        "elementType": "all",
				        "stylers": [
					        {
						        "color": "#6692ab"
					        },
					        {
						        "visibility": "on"
					        }
				        ]
			        },
			        {
				        "featureType": "water",
				        "elementType": "geometry.fill",
				        "stylers": [
					        {
						        "visibility": "on"
					        },
					        {
						        "color": "#54585a"
					        }
				        ]
			        },
			        {
				        "featureType": "water",
				        "elementType": "labels.text",
				        "stylers": [
					        {
						        "visibility": "on"
					        }
				        ]
			        },
			        {
				        "featureType": "water",
				        "elementType": "labels.text.fill",
				        "stylers": [
					        {
						        "visibility": "on"
					        },
					        {
						        "saturation": "-25"
					        },
					        {
						        "lightness": "-23"
					        },
					        {
						        "gamma": "0.00"
					        },
					        {
						        "color": "#ffffff"
					        }
				        ]
			        }
		        ];
		        var mapOptions = {
			        zoom: 16
		        };
		        var markerOptions = {
			        title: 'Cabinet de Services Financiers Plani-Vie',
			        icon: {
				        anchor: new google.maps.Point(15, 48),
				        url: Perseides.Base.imgPath + 'location-pin.png'
			        }
		        };

		        return Perseides.Functions.googleMap('gmap', position, couleurMap, mapOptions, markerOptions);
	        };

	        var adresses = $('#gmap').data('adresses');
	        var position = [];
	        if( adresses ) {
		        adresses = adresses.split(';;');
		        adresses = adresses.filter(Boolean);

		        var ctr = 0;
		        adresses.forEach(function(element, index, array){

			        var request = new XMLHttpRequest();
			        request.open('GET', Perseides.Base.jsPath + 'pt-gmap-geocode.php?adresse='+array[index]+'&apiKey='+apiKey, true);

			        request.onload = function () {
				        if (request.status >= 200 && request.status < 400) {
					        // Success!
					        var data = JSON.parse(request.responseText);

					        // Données
					        ctr++;
					        if( data.results[0].length !== 0 )
						        position.push( data.results[0].geometry.location );

					        // Lorsque toutes les adresses ont été récupérés
					        if (ctr === array.length)
						        initGMap.initialize( position );

				        } else {
					        // We reached our target server, but it returned an error
					        console.log('We reached our target server, but it returned an error');
				        }
			        };

			        request.onerror = function () {
				        // There was a connection error of some sort
				        console.log('There was a connection error of some sort');
			        };

			        request.send();

		        });
	        }
	        else {
		        position = [
			        {lat: 48.4252817, lng: -71.1831153}
		        ];
	        }
        };


	    /**
	     * Initialisation du slider de la page d'accueil
	     */
	    app.initHomeSlider = function() {
		    "use strict";

		    // Variables
            var $slider = $('#homeSlider');

		    if($slider.length !== 0) {

		        var $sliderNav = $('#homeSliderNav'),
		            $backgroundContainer = $('#homeSliderBackgrounds');

			    // Paramètres custom
			    var customParams = {
				    appendArrows: $sliderNav,
				    prevArrow: '<button type="button" class="hero--slider__slider-nav__prev slick-prev icon-container"><svg class="icon icon-fleche-gauche-mince"><use xlink:href="#icon-fleche-gauche-mince"/></svg></button>',
				    nextArrow: '<button type="button" class="hero--slider__slider-nav__next slick-next icon-container"><svg class="icon icon-fleche-droite-mince"><use xlink:href="#icon-fleche-droite-mince"/></svg></button>',
				    draggable: false,
				    swipe: false,
				    autoplaySpeed: 5000
			    };

			    $slider.on('init', function(event, slick){
				    "use strict";

				    // Variables
				    var $initSlide = $(slick.$slides);

				    // Récupération de la bonne image
				    app.getHomeSliderImageFromResolution(event);

				    $initSlide.each(function (i, e) {
					    var actif = 'opacity: 0; z-index: 0';
					    if(i === 0) {
						    actif = 'opacity: 1; z-index: 1';
					    }
					    $backgroundContainer.append('<div id="homeSliderBg' + i + '" class="hero--slider__backgrounds__bg" style="background-image: url(' + $(e).data('image') + '); ' + actif + '"></div>');
				    });
			    });

			    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				    "use strict";

				    // Variables
				    var $currentBackground = $('#homeSliderBg' + currentSlide),
				        $nextBackground = $('#homeSliderBg' + nextSlide);

				    // Appliquer la transition
				    $currentBackground.css({
					    'opacity': 0,
					    'z-index': 0
				    });
				    $nextBackground.css({
					    'opacity': 1,
					    'z-index': 1
				    });
			    });

			    return Perseides.Functions.initSlickSlider($slider, customParams);
		    }
        };


	    /**
	     * Récupération de la bonne image du slider de la page d'accueil selon la résolution
	     */
	    app.getHomeSliderImageFromResolution = function(event) {
		    "use strict";

		    // Variables
		    var $slider = $('#homeSlider'),
		        $sliderImages = $slider.find('.hero--slider__slider__content'),
		        resolution = 'desktop';

		    if($slider.length !== 0) {

			    // Détection de la résolution
			    if(Analyzr.isMobileSmallSize || Analyzr.isMobileMediumSize || Analyzr.isMobileLargeSize) {
				    resolution = 'mobile';

				    if(Analyzr.isHighResolution) {
					    resolution = 'mobile-retina';
				    }
			    }
			    else if(Analyzr.isTabletSmallSize || Analyzr.isTabletMediumSize) {
				    resolution = 'tablet';

				    if(Analyzr.isHighResolution) {
					    resolution = 'tablet-retina';
				    }
			    }
			    else if(Analyzr.isTabletLargeSize) {
				    resolution = 'tablet-large';
			    }

			    // Traitement
			    $sliderImages.each(function (i, e) {

				    // On met la bonne image dans l'attribut "data-image"
				    $(e).data('image', $(e).data('image-' + resolution));

				    // Si c'est sur le resize, il faut changer l'image directement dans son container
				    if(event.type === 'resize') {

					    $('#homeSliderBg' + i).css('background-image', 'url("' + $(e).data('image-' + resolution) + '")');

				    }

			    });

		    }
	    };


	    /**
	     * Récupération de la bonne image de background du hero selon la résolution
	     */
	    app.getHeroImageFromResolution = function() {
		    "use strict";

		    // Variables
		    var $images = $('#heroContent'),
		        $heroBg = $('#heroBg'),
		        resolution = 'desktop';

		    if( $images.length !== 0 ) {

			    if( $heroBg.length === 0 ) {
				    $('#heroBackgrounds').append('<div id="heroBg" class="hero__backgrounds__bg"></div>');
				    app.getHeroImageFromResolution();
			    }
			    else {
				    // Détection de la résolution
				    if(Analyzr.isMobileSmallSize || Analyzr.isMobileMediumSize || Analyzr.isMobileLargeSize) {
					    resolution = 'mobile';

					    if(Analyzr.isHighResolution) {
						    resolution = 'mobile-retina';
					    }
				    }
				    else if(Analyzr.isTabletSmallSize || Analyzr.isTabletMediumSize) {
					    resolution = 'tablet';

					    if(Analyzr.isHighResolution) {
						    resolution = 'tablet-retina';
					    }
				    }
				    else if(Analyzr.isTabletLargeSize) {
					    resolution = 'tablet-large';
				    }

				    // Traitement
				    // On met la bonne image dans l'attribut "data-image"
				    $heroBg.css('background-image', 'url("' + $images.data('image-' + resolution) + '")');
			    }
		    }
	    };


	    /**
	     * Fermeture des "popup" lors de certains "events"
	     */
	    app.closePopupsOnEvents = function() {
		    "use strict";

		    // En cliquant en-dehors du popup
		    $( 'body' ).on( 'click', function ( e ) {

			    // Fermeture du sous-menu en affichage desktop avec un appareil touch
			    if( $('#mainNav').find('.firstClickDone').length !== 0 ) {

				    $( '#mainNav' ).find( '.menu-item-has-children' ).each( function(i, el) {

					    var targetClickedIndex = $( e.target ).closest( '.menu-item-has-children' ).index();

					    if( $( el ).index() != targetClickedIndex ) {

						    $( el ).find( '.firstClickDone' ).removeClass( 'firstClickDone' );

					    }

				    } );
			    }

			    // Fermeture du sous-menu en affichage desktop avec un appareil touch
			    if( $('#footerMainNav').find('.firstClickDone').length !== 0 ) {

				    $( '#footerMainNav' ).find( '.menu-item-has-children' ).each( function(i, el) {

					    var targetClickedIndex = $( e.target ).closest( '.menu-item-has-children' ).index();

					    if( $( el ).index() != targetClickedIndex ) {

						    $( el ).find( '.firstClickDone' ).removeClass( 'firstClickDone' );

					    }

				    } );
			    }
		    } );
	    };


	    /**
	     * Toggle du menu secondaire en version mobile
	     */
	    app.toggleSecondaryMenu = function() {
		    var menuSecToggler = '#menuSecToggler',
		        $menuSecToggler = $(menuSecToggler),
		        togglerButton = '#menuSecTogglerButton',
		        $togglerButton = $(togglerButton),
		        $menuSecNav = $menuSecToggler.next('.sidebar__secmenu__nav');

		    if( $menuSecToggler.length !== 0 ) {

			    if( Analyzr.isMobileSmallSize == true || Analyzr.isMobileMediumSize == true || Analyzr.isMobileLargeSize == true || Analyzr.isTabletSmallSize == true || Analyzr.isTabletMediumSize == true ) {

				    $togglerButton.off( 'click' );
				    $togglerButton.on( 'click', function() {
					    $togglerButton.toggleClass('opened');
					    $menuSecNav.toggleClass('hidden');
				    });
			    }
			    else {
				    $togglerButton.off( 'click' );
				    $togglerButton.removeClass('opened');
				    $menuSecNav.removeClass('hidden');
			    }
		    }
	    };


	    /**
	     * Initialisation de l'ajustement amical pour la bonne navigation par tabulation pour le menu principal
	     */
	    app.initMainMenuFriendlyTabNavigation = function() {
		    var mainNav = "#mainNav",
		        findFirstLevelMenu = ".menu > .menu-item",
		        firstLevelMenuLink = "#mainNav .menu > .menu-item > a",
		        childrenMenuLink = "#mainNav .sub-menu a",
			    closestElement = ".menu-item-has-children";

		    Perseides.Functions.mainMenuFriendlyTabNavigation(mainNav, findFirstLevelMenu, firstLevelMenuLink, childrenMenuLink, closestElement);
	    };


    };

    Perseides.Theme = new PerseidesTheme();
}(jQuery, window, document, Perseides, Analyzr));